import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { AgGridModule } from 'ag-grid-angular';
import { AgGridDirective } from './ag-grid.directive';

@NgModule({
  imports: [CommonModule, AgGridModule],
  exports: [AgGridDirective, AgGridModule],
  declarations: [AgGridDirective],
})
export class Y42AgGridModule {}
